var map = {
	"./en.json": [
		"a5ee",
		"chunk-2d208c8a"
	],
	"./fr.json": [
		"86c5",
		"chunk-2d0deca6"
	],
	"./ru.json": [
		"6a3a",
		"chunk-2d0d9faf"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2fc7";
module.exports = webpackAsyncContext;